import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "title", "titleClassName", "image", "body", "linkTag", "linkAttributes", "linkText", "onClickLink"];
import React from 'react';
import classNames from 'classnames';
import { Col, Card, CardTitle, CardText, CardImg, CardBody } from 'reactstrap';
var blockClass = 'search-result';
var Result = function Result(_ref) {
  var className = _ref.className,
    title = _ref.title,
    titleClassName = _ref.titleClassName,
    image = _ref.image,
    body = _ref.body,
    LinkTag = _ref.linkTag,
    linkAttributes = _ref.linkAttributes,
    linkText = _ref.linkText,
    onClickLink = _ref.onClickLink,
    attrs = _objectWithoutPropertiesLoose(_ref, _excluded);
  var classes = classNames(blockClass, 'position-relative', className);
  var titleClasses = classNames(blockClass + "__title", titleClassName);
  var linkClasses = classNames(blockClass + "__link", 'stretched-link', linkAttributes && linkAttributes.className ? linkAttributes.className : '');
  return /*#__PURE__*/React.createElement(Col, _extends({
    className: classes
  }, attrs), /*#__PURE__*/React.createElement(Card, {
    className: blockClass + "__card h-100"
  }, image && /*#__PURE__*/React.createElement(CardImg, {
    className: blockClass + "__image",
    top: true,
    src: image,
    alt: title
  }), /*#__PURE__*/React.createElement(CardBody, {
    className: blockClass + "__content"
  }, title && /*#__PURE__*/React.createElement(CardTitle, {
    className: titleClasses
  }, title), body && /*#__PURE__*/React.createElement(CardText, {
    className: blockClass + "__body"
  }, body), LinkTag && /*#__PURE__*/React.createElement(LinkTag, _extends({
    title: title
  }, linkAttributes, {
    className: linkClasses,
    onClick: onClickLink
  }), linkText))));
};
export default Result;
Result.defaultProps = {
  linkTag: 'a',
  titleClassName: 'h5'
};